jQuery(document).ready(function () {
    jQuery('body.template-collection.ingredients form#FacetSortForm').wrapAll('<div class="page-width"></div>');
});

jQuery(document).ready(function () {
    jQuery('.section-header nav ul.list-menu li summary .icon.icon-caret, .section-header nav ul.list-menu li summary.header__menu-item span').click(function () {
        //jQuery('html').toggleClass('submenu-open');
    });
});
$(document).on("click", function () {
    var menu_chk_wrap = $(".section-header nav ul.list-menu li summary.header__menu-item");
    menu_chk_wrap.each(function () {
        var menu_chk = $(this).attr("aria-expanded");
        console.log("Value is " + menu_chk);
        if (menu_chk == 'true') {
            jQuery('html').addClass('submenu-open');
            return false;
        } else {
            jQuery('html').removeClass('submenu-open');
        }
    });
    /*if ($(a.target).is(".section-header nav ul.list-menu li summary .icon.icon-caret, .section-header nav ul.list-menu li summary.header__menu-item span, .section-header nav ul.list-menu li summary.header__menu-item+.mega-menu__content, .section-header nav ul.list-menu li header-menu .mega-menu__content .menU_lvl-1-wrap") === false) {
        jQuery('html').removeClass('submenu-open');
    }*/
});

jQuery(document).ready(function () {
    jQuery('body.account').addClass('common_header_changes');
    jQuery('body.create-account').addClass('common_header_changes');
    jQuery('body.challenge').addClass('common_header_changes');
    jQuery('body.reset-account').addClass('common_header_changes');
    jQuery('body.addresses').addClass('common_header_changes');
    jQuery('body.template-cart').addClass('common_header_changes');
    jQuery('body.template-list-collections.collections').addClass('common_header_changes');
    jQuery('body.template-search').addClass('common_header_changes');
    jQuery('body.contact').addClass('common_header_changes');
    jQuery('body.terms-of-service').addClass('common_header_changes');
    jQuery('body.privacy-policy').addClass('common_header_changes');
    jQuery('body.refund-policy').addClass('common_header_changes');
    jQuery('body.shipping-policy').addClass('common_header_changes');
    jQuery('body.wishlist').addClass('common_header_changes');
    jQuery('body.template-article').addClass('common_header_changes');
    jQuery('body.404-not-found').addClass('common_header_changes');
});


if (window.matchMedia("(max-width: 767px)").matches) {
    jQuery(function () {
        jQuery(".footer-block--menu .footer-block__details-content").css("display", "none");
        jQuery(".footer-block--menu .footer-block__heading ").addClass("open");

        jQuery(".footer-block__heading ").click(function () {
            jQuery(".open").not(this).removeClass("open").next().slideUp(300);
            jQuery(this).toggleClass("open").next().slideToggle(300);
        });
    });
}


$(window).scroll(function () {
    var sticky = $('body'),
        scroll = $(window).scrollTop();
    if (scroll >= 30) sticky.addClass('fixed');
    else sticky.removeClass('fixed');
});

// ===product details hou to use video====
jQuery(document).ready(function () {
    jQuery('.play #how_to_use_video').parent().on('click', function () {
        if (jQuery(this).children(".play #how_to_use_video").get(0).paused) {
            jQuery(this).children(".play #how_to_use_video").get(0).play();
            jQuery(this).children(".play .play-btn").fadeOut();
            jQuery(this).children(".play #how_to_use_video").attr('controls', 'true');
        } else {
            jQuery(this).children(".play #how_to_use_video").get(0).pause();
            jQuery(this).children(".play .play-btn").fadeIn();
            jQuery(this).children(".play #how_to_use_video").removeAttr('controls', 'false');
        }
    });
});

jQuery(document).ready(function () {
    jQuery('.shopify-policy__body ul.table-of-content li a').click(function (e) {
        e.preventDefault();
        var target = jQuery(jQuery(this).attr('href'));
        if (target.length) {
            var scrollTo = target.offset().top;
            jQuery('body, html').animate({
                scrollTop: scrollTo + 'px'
            }, 800);
        }
    });
});

// ===== search ====
jQuery(document).ready(function () {
    jQuery('.modal__toggle-open.icon.icon-search').click(function () {
        jQuery('body').addClass('new-animation-hide');
    });
    jQuery('.search-modal__close-button').click(function () {
        jQuery('body').removeClass('new-animation-hide');
    });
});

